import React, {Component} from 'react';
import {Row, Col} from "react-bootstrap";
import ReactNotify from 'react-notify';
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import KonfiguracjaHeader from "../../../../../shared/headers/KonfiguracjaHeader";
import PojazdyService from "../../pojazdy/PojazdyService";
import PolaczenieEkipIPojazdowService from "./PolaczenieEkipIPojazdowService";
import utilitiesTopSelect from "../../../../../utilities/utilitiesTopSelect";
import PolaczenieEkipIPojazdowTable from "./components/PolaczenieEkipIPojazdowTable";
import PolaczenieEkipyIPojazdowForm from "./components/PolaczenieEkipyIPojazdowForm";
import EkipyService from "../definicjaEkipy/EkipyService";
import ScrollUtilities from "../../../../../utilities/ScrollUtilities";

export default class PolaczenieEkipIPojazdowContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pokazFormularz: false,
            polaczenia: [],
            polaczenie:null,
            ekipy: [],
            pojazdy: [],
            ekipyTS: [],
        };

        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onClickEdytuj = this.onClickEdytuj.bind(this)
        this.onClickUsun = this.onClickUsun.bind(this)
        this.zamknijFormularz = this.zamknijFormularz.bind(this)
    }

    componentDidMount() {
        this.pobierzEkipy()
        this.pobierzPojazdy()
    }

    pobierzPolaczenia(arr) {
        PolaczenieEkipIPojazdowService.getEkipaPoj().then(function (response) {

            let array = Array.from(response.data, item => {
                let pojazd = arr.find(p => p.idPo === item.idPo)
                if (Boolean(pojazd)) {
                    return {
                        idEk: item.idEk,
                        idEkp: item.idEkp,
                        kodEk: item.kodEk,
                        nazwaEk: item.nazwaEk,
                        idPo: item.idPo,
                        zmiana: item.zmiana,
                        marka: pojazd.marka,
                        model: pojazd.model,
                        nrRej: pojazd.nrRej,
                        ileMiejsc: pojazd.ileMiejsc,
                        informacje: pojazd.informacje
                    }
                }
            })

            this.setState({polaczenia: array})
        }.bind(this))
    }

    pobierzPojazdy() {
        PojazdyService.getPojazdy().then(function (response) {
            let arr = Array.from(response.data.content, item => {
                let wifi = ''
                if(item.wifi){
                    wifi = ', wifi: '+item.wifi
                }
                return {
                    ...item,
                    informacje: item.marka + ' ' + item.model + ' ' + item.nrRej +' '+wifi
                }
            })
            this.setState({pojazdy: arr})
            this.pobierzPolaczenia(arr)
        }.bind(this))
    }

    pobierzEkipy() {
        EkipyService.getEkipy().then(function (response) {
            let arr = Array.from(response.data.content, item => {
                return {
                    idEk: item.idEk,
                    kodEk: item.kodEk,
                    kolor: item.kolor,
                    nazwaEk: item.nazwaEk,
                    informacje: item.kodEk + ' ' + item.nazwaEk
                }
            })
            this.setState({
                ekipy: arr,
                ekipyTS: utilitiesTopSelect.changeTabOfObjectsToSimpleObject(response.data.content, "idEk", 'kodEk', 'nazwaEk', null)
            })
        }.bind(this))
    }

    zamknijFormularz(){
        this.setState({pokazFormularz:false,polaczenie:null})
    }

    onClickZapisz(obj, czyEdycja) {
        if (czyEdycja) {
            PolaczenieEkipIPojazdowService.editEkipaPoj(this.state.polaczenie.idEkp, obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie edytowano połączenie', "", 3000)
                    this.pobierzPolaczenia(this.state.pojazdy);                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas edycji połączenia', "", 3000)
                }
            }.bind(this))
        }
        else {
            PolaczenieEkipIPojazdowService.addEkipaPoj(obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie dodano połączenie', "", 3000)
                    this.pobierzPolaczenia(this.state.pojazdy);                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas dodawania połączenia', "", 3000)
                }
            }.bind(this))
        }

        this.zamknijFormularz();
    }

    onClickEdytuj(obj) {
        this.setState({pokazFormularz:true,polaczenie:obj})
        ScrollUtilities.scrollToTop()
    }

    onClickUsun(obj) {
        if (window.confirm('Czy usunąc połączenie?')) {
            PolaczenieEkipIPojazdowService.deleteEkipaPoj(obj.idEkp).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie usunięto połączenie', "", 3000)
                    this.pobierzPolaczenia(this.state.pojazdy);
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas usuwania połączenia', "", 3000)
                }
            }.bind(this))

        }
    }

    render() {

        return (
            <div>
                <ReactNotify ref='notificator'/>
                <Row>
                    <Col xs={12}>
                        <TopIf isTrue={!Boolean(this.state.pokazFormularz)}>
                            <KonfiguracjaHeader pokazFormularz={()=>{this.setState({pokazFormularz:true});ScrollUtilities.scrollToTop()}}
                                                tekstDodaj={'Dodaj pojazd do ekipy'}
                                                pokazButtonSzukaj={false}
                            />
                        </TopIf>
                        <TopIf isTrue={Boolean(this.state.pokazFormularz)}>
                             <PolaczenieEkipyIPojazdowForm
                                handleClickZapisz={this.onClickZapisz}
                                handleClickAnuluj={this.zamknijFormularz}
                                polaczenie={this.state.polaczenie}
                                pojazdy={this.state.pojazdy}
                                ekipy={this.state.ekipy}
                                polaczenia={this.state.polaczenia}
                            />
                        </TopIf>
                        <PolaczenieEkipIPojazdowTable
                            data={this.state.polaczenia}
                            handleEdytuj={this.onClickEdytuj}
                            handleUsun={this.onClickUsun}
                            wlaczSzukanie={true}
                            ekipy={this.state.ekipy}
                            ekipyTS={this.state.ekipyTS}
                            pojazdy={this.state.pojazdy}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/ekipy/polaczenieEkipIPojazdow/PolaczenieEkipIPojazdowContainer.js